import axios from "axios";

export function updateAllScreens(token) {
    return axios.post(
        process.env.REACT_APP_API_URL + '/updateAllScreens',
        {},
        {
            headers: {
                Authorization: `${token}`,
                'Content-Type': 'application/json',
            },
        }
    );
}
